import { getProcuredOfferCalendarDatesMessage } from '@shared/v2/utils/procuredOffer';

import useProcuredOffer from '@/components/PackagePage/hooks/useProcuredOffer';

export type UseSearchPanelMessagingOptions = {
  campaign: { destinationPromoText: { text: string } } | null;
};

export const useSearchPanelMessaging = ({
  campaign,
}: UseSearchPanelMessagingOptions) => {
  const procuredOffer = useProcuredOffer();
  const campaignMessage = campaign?.destinationPromoText.text;
  const procuredOfferDatesMessage = !campaignMessage
    ? getProcuredOfferCalendarDatesMessage(procuredOffer)
    : undefined;

  return { campaignMessage, procuredOfferDatesMessage };
};
